import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=cdd3d154&scoped=true&class=notifications"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=cdd3d154&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd3d154",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdd3d154')) {
      api.createRecord('cdd3d154', component.options)
    } else {
      api.reload('cdd3d154', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=cdd3d154&scoped=true&class=notifications", function () {
      api.rerender('cdd3d154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Notifications/Notifications.vue"
export default component.exports